import styled from "styled-components";

export const Section = styled.section`
	scroll-margin-top: 96px;
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const SectionTitle = styled.h2`
	margin: 0;
	font-size: 1.5rem;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.textPrimary};
`;

export const SectionIntro = styled.p`
	margin: 0;
	color: ${({ theme }) => theme.colors.textSecondary};
	font-size: 0.9rem;
	line-height: 1.5;
`;

export const Card = styled.article`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.lightergray};
	border-radius: 12px;
	padding: 16px;
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

export const CardTitle = styled.h3`
	margin: 0;
	font-size: 0.95rem;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.textPrimary};
`;

export const Row = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 12px;
`;

export const Stack = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	min-width: 220px;
	flex: 1;
`;

export const Caption = styled.span`
	font-size: 0.75rem;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.textSecondary};
`;
